import { zodResolver } from '@hookform/resolvers/zod';
import { Button, FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { z as zod } from 'zod';
import Grid from '@mui/material/Unstable_Grid2';
import { useEffect, useState } from 'react';
import { readTitlePoolId } from '@/api/asset/pool/read';
import { STAKING_USER_STATE } from '@/lib/common/name-space';
import { addUserPool } from '@/api/asset/pool/create';
import { toast } from 'react-toastify';

const schema = zod.object({
  poolId: zod.string().min(1, { message: '필수 입력' }),
  address: zod.string().min(1, { message: '필수 입력' }),
  stakeAmt: zod.string().min(1, { message: '필수 입력' }),
  hash: zod.string().min(1, { message: '필수 입력' }),
  regDt: zod.string().min(1, { message: '2024-11-12 18:10:37 형태로 입력' }),
  ticker: zod.string().min(1, { message: '필수 입력' }),
  stakeState: zod.number().refine((val) => val !== -1, { message: 'stake is required' }), // -1 제외
});

type Values = zod.infer<typeof schema>;
const defaultValues = {
  poolId: '',
  address: '',
  stakeAmt: '',
  hash: '',
  regDt: '',
  ticker: '',
  stakeState: -1,
} satisfies Values;

const status = [
  {
    no: 0,
    type: 'staking',
    state: STAKING_USER_STATE.STAKING,
  },

  {
    no: 1,
    type: 'unstaking',
    state: STAKING_USER_STATE.UNSTAKING,
  },

  {
    no: 2,
    type: 'withdraw',
    state: STAKING_USER_STATE.WITHDRAW,
  },
];
export default function RegisterForm() {
  const [list, setList] = useState<{ title: string; poolId: string }[] | null>(null);
  useEffect(() => {
    (async () => {
      const re = await readTitlePoolId();
      console.log(re);
      setList(re.data);
    })();
    return () => {};
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  const onSubmit = async (data: Values) => {
    console.log(data);

    const re = await addUserPool(data);

    // const re = await createAddress(data);
    if (re.status !== 200) {
      return;
    }
    toast.success('성공');
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid md={6} xs={12}>
            <Controller
              control={control}
              name="poolId"
              render={({ field }) => (
                <FormControl fullWidth required>
                  <InputLabel>title</InputLabel>
                  <Select
                    defaultValue=""
                    label="poolId"
                    variant="outlined"
                    {...field}
                    value={field.value !== undefined ? String(field.value) : ''}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    <MenuItem value="">선택 안 함</MenuItem>
                    {list &&
                      list.map((option) => (
                        <MenuItem key={option.poolId} value={option.poolId}>
                          {option.title}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.poolId && <FormHelperText>{errors.poolId.message}</FormHelperText>}
                </FormControl>
              )}
            />
          </Grid>
          <Grid xs={12}>
            <Controller
              control={control}
              name="address"
              render={({ field }) => (
                <FormControl error={Boolean(errors.address)} fullWidth required>
                  <InputLabel>address</InputLabel>
                  <OutlinedInput {...field} label="address" type="text" fullWidth />
                  {errors.address ? <FormHelperText>{errors.address.message}</FormHelperText> : null}
                </FormControl>
              )}
            />
          </Grid>

          <Grid xs={12}>
            <Controller
              control={control}
              name="hash"
              render={({ field }) => (
                <FormControl error={Boolean(errors.hash)} fullWidth required>
                  <InputLabel>hash</InputLabel>
                  <OutlinedInput {...field} label="hash" type="text" fullWidth />
                </FormControl>
              )}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <Controller
              control={control}
              name="stakeAmt"
              render={({ field }) => (
                <FormControl error={Boolean(errors.stakeAmt)} fullWidth required>
                  <InputLabel>stake_amt</InputLabel>
                  <OutlinedInput {...field} label="stakeAmt" type="text" />
                </FormControl>
              )}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <Controller
              control={control}
              name="regDt"
              render={({ field }) => (
                <FormControl error={Boolean(errors.regDt)} fullWidth required>
                  <InputLabel>reg_dt</InputLabel>
                  <OutlinedInput {...field} label="regDt" type="text" />
                  <FormHelperText>※ex: 2024-11-12 18:10:37 </FormHelperText>
                </FormControl>
              )}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <Controller
              control={control}
              name="ticker"
              render={({ field }) => (
                <FormControl error={Boolean(errors.ticker)} fullWidth required>
                  <InputLabel>ticker</InputLabel>
                  <OutlinedInput {...field} label="ticker" type="text" />
                </FormControl>
              )}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <Controller
              control={control}
              name="stakeState"
              render={({ field }) => (
                <FormControl error={Boolean(errors.stakeState)} fullWidth required>
                  <InputLabel>status</InputLabel>
                  <Select
                    label="status"
                    variant="outlined"
                    {...field}
                    value={field.value !== undefined ? String(field.value) : ''}
                    onChange={(e) => field.onChange(parseInt(e.target.value))}
                  >
                    <MenuItem value="-1">선택 안 함</MenuItem>
                    {status &&
                      status.map((option) => (
                        <MenuItem key={option.no} value={option.state}>
                          {option.type}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.stakeState && <FormHelperText>{errors.stakeState.message}</FormHelperText>}
                </FormControl>
              )}
            />
          </Grid>

          <Grid xs={12}>
            <Button variant="contained" type="submit" fullWidth>
              생성
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
